import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { environment } from 'src/environments/environment';
import { CommunityPatrolService } from '../../services/community-patrol.service';
import Swal from 'sweetalert2';
import { logger } from '../../util/Logger';


const className = "CommunityListComponent";

@Component({
  selector: 'app-community-patrol-list',
  templateUrl: './community-patrol-list.component.html',
  styleUrls: ['./community-patrol-list.component.sass']
})
export class CommunityPatrolListComponent {
  constructor(
    private _notifications: NotificationsService,
    private __router: Router,
    public __CommunityPatrolService: CommunityPatrolService,
    public route: ActivatedRoute
  ) {
    this.getCellCollection();
  }

  public communityList = <any>[];
  public totalCountActive: number = 0;
  public currentPageActive: number = 1;
  public pageLimitActive: number = environment.defaultCollectionLimit || 10;
  public searchActive: string = "";
  public clientIdArray: string[] = [];
  public communityIdArray: string[] = [];

  pageChangedActive(page: number) {
    this.currentPageActive = page;
    this.getCellCollection();
  }

  getCellCollection() {
    this.__CommunityPatrolService.listingCommunityPatrol({ page: this.currentPageActive, limit: this.pageLimitActive, search: this.searchActive, filter: {} }).subscribe({
      next: response => {
        this.communityList = response.data.rows;
        this.totalCountActive = response.data.count;
      },
      error: err => {
        console.error(err);
        this._notifications.error("ERROR", err.error && err.error.message || err.message || "", {})
      }
    });
  }

  searching(searchText: string) {
    this.searchActive = searchText;
    this.getCellCollection();
  }

  /**
   * selectItemActive
   */
  public selectItemActive(data: { clientId: string, id: string }): void {
    this.__router.navigate([`/community-patrol/edit`, data.clientId], { queryParams: { communityId: data.id } });
  }

  addNew() {
    if (this.clientIdArray.length == 0) {
      Swal.fire('checkOut', 'please select minimum one client for checkOut !', 'error')
    } else {
      this.__router.navigate([`/community-patrol/edit`, this.clientIdArray.join('/')], { queryParams: { communityyId: this.communityIdArray.join('/') } });
    }
  }

  isClientSelected(clientId: string): boolean {
    return this.clientIdArray.includes(clientId);
  }


  /**
   * Adds or removes a clientId from the clientIdArray based on the provided parameters.
   *
   * @param {string} clientId - The ID of the client to add or remove.
   * @param {string} communityId - The ID of the cell to add or remove.
   * @param {boolean} include - Specifies whether to include or remove the clientId.
   * @returns {undefined} - This function does not return a value.
   *
   */

  selectedClient(clientId: string, include: boolean, communityId: string) {
    const signature = className + `.bulkCheckOut: ClientId[${clientId}] Include[${include}]] communityId[${communityId}] Include[${include}]]`;

    const clientIdIndex = this.clientIdArray.indexOf(clientId);
    const clientIdExists = clientIdIndex !== -1;
    const communityIdIndex = this.communityIdArray.indexOf(communityId);
    const communityIdExist = communityIdIndex !== -1

    logger.silly(signature + 'Started');
    if (include && !clientIdExists && !communityIdExist) {
      this.clientIdArray.push(clientId);
      this.communityIdArray.push(communityId);
    } else if (!include && clientIdExists && communityIdExist) {
      this.clientIdArray.splice(clientIdIndex, 1);
      this.communityIdArray.splice(communityIdIndex, 1)
    }
  }
}

